import AvailabilityStatus from './AvailabilityStatus';
export default AvailabilityStatus;
